---
title: "Wie das Inventar entsteht"
slug: how-inventory-works
description: "Pakete erscheinen automatisch im Inventar, sobald sie gescannt werden — es gibt keinen manuellen Eingabeschritt."
keywords:
  - Inventar
  - Scan
  - Paket
  - Bestand
  - Inventarisierung
  - GRAI
---

## Inventar entsteht durch Scannen

Sie müssen keine Pakete manuell ins System eingeben. Jedes Mal, wenn ein Paket an einem internen Standort gescannt wird — ob beim Senden oder Empfangen — erfasst hey circle das Paket automatisch im Inventar.

Das Scannen **ist** die Inventarisierung. Es gibt keinen separaten "Inventar anlegen"-Schritt.

## Wie ein Paket erstmals auftaucht

Wenn Sie ein Paket zum ersten Mal scannen, liest hey circle den GRAI-Code (den Barcode oder QR-Code auf dem Paket). Das Paket wird daraufhin automatisch:

1. Ihrem Standort zugeordnet
2. Im Inventar als **"Verfügbar"** eingetragen
3. In der Aktivitätsliste des Standorts sichtbar

## Was nach einem Scan-Vorgang passiert

| Scan-Typ | Was mit dem Inventar passiert |
|---|---|
| Paket senden (intern → intern) | Paket wechselt Standort; bleibt im Inventar |
| Paket senden (intern → extern) | Paket verlässt den internen Bestand; Status wird "Unterwegs" |
| Paket empfangen | Paket kehrt in den Bestand zurück; Status wird "Verfügbar" |

## Kein manueller Inventaraufbau nötig

Während der Ersteinrichtung müssen Sie **keinen** Schritt zur Inventarisierung durchführen. Sobald Ihr Team beginnt, Pakete zu senden und zu empfangen, füllt sich das Inventar automatisch.

Wenn ein Paket im System noch unbekannt ist (GRAI noch nie gescannt), werden Sie beim ersten Scan aufgefordert, es zu registrieren. Danach ist es dauerhaft im System.

## Inventar einsehen

Alle Rollen — Admin, Manager und Scanner — können die vollständige Inventarliste im oberen Menü unter **Einstellungen → Inventar** öffnen. Die aggregierte Übersicht **Bestandsgesundheit** (Paketanzahl nach Status und Defektrate je Standort) ist Teil des Analytik-Dashboards und steht nur Admins und Managern zur Verfügung.

Eine Übersicht der Berechtigungen finden Sie im Artikel [Benutzerrollen](/app/help?article=user-roles).

## Verwandte Artikel

- [Interne vs. externe Standorte](/app/help?article=internal-vs-external-locations)
- [Pakete senden](/app/help?article=sending-a-package)
- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Ersteinrichtung](/app/help?article=initial-setup)
